import React, {useState} from 'react';
import {FmlxIcon} from 'fmlx-common-ui';
import PropTypes from 'prop-types';

import withIntl from '../../../lib/withIntl';
import FastTextBox from '../../../components/Inputs/FastTextBox';
import {TextBoxDecoration} from '../../../constants/UIComponentEnum';

function LabwareSearch({intl, onKeywordChange, deepWellThreshold}) {
  const [keyword, setKeyword] = useState();

  const handleChangeKeyword = (newVal) => {
    const newKeyword = newVal.toLowerCase();
    const isDW = newKeyword.includes('dw');

    const filterLabwareCondition = (labwareObject) =>
      (isDW && labwareObject.wellDepth > deepWellThreshold) || labwareObject.name.toLowerCase().includes(newKeyword);

    onKeywordChange(() => filterLabwareCondition);
    setKeyword(newVal);
  };

  return (
    <FastTextBox
      className="labware-list-content__search-labware-field"
      icon={<FmlxIcon name="Search" />}
      fontSize=".7rem"
      decoration={TextBoxDecoration.ICON}
      value={keyword}
      onChange={handleChangeKeyword}
      placeholder={intl.formatMessage({id: 'protocolEditor.labwareList.searchTextBox.placeholder'})}
    />
  );
}

LabwareSearch.propTypes = {
  intl: PropTypes.any.isRequired,
  onKeywordChange: PropTypes.func.isRequired,
  deepWellThreshold: PropTypes.number.isRequired,
};

export default withIntl(LabwareSearch);
